import React from 'react';
import  Card  from '../Card/Card';
import { Button } from 'semantic-ui-react';
import { FilterDrawerColumn } from './FilterDrawerColumn';

export class FilterDrawer extends React.Component {
  constructor() {
    super();
    this.state = {
      whoChanged: ''
    };
  }

  interceptAndHandleFilterChange = (args) => {
    this.setState({ whoChanged: args.name });
    this.props.onChange(args);
  };

  render() {
    const { options, onClear, selected, style, onClose } = this.props;
    const { whoChanged } = this.state;

    return (
      <Card
        className="floating filter-drawer"
        bodyStyle={{ padding: 0 }}
        style={{ ...style }}>
        <div className="filter-content">
          {options &&
            options.map((filter, i) => (
              <FilterDrawerColumn
                key={i}
                title={filter.title}
                name={filter.name}
                filterOptions={filter.values}
                changeFilter={this.interceptAndHandleFilterChange}
                selectedFilters={selected}
                whoChanged={whoChanged}
              />
            ))}
        </div>
        <div className="filter-footer">
          <div className="left">
            <button onClick={onClear}>
              <i className="undo icon" />
              Clear All Filters
            </button>
          </div>
          <div className="right">
            <Button primary basic onClick={onClose}>
              Done
            </Button>
          </div>
        </div>
      </Card>
    );
  }
}

export default FilterDrawer;
